export const SWIPE_TRANSITION_DURATION: number = 500;
export const SWIPE_BOUNDARY_RATIO = 0.5;
export const SHOULD_LOOP: boolean = true;
